// Load External Libraries
import AOS from 'aos'
//import 'owl.carousel';
//import {jarallax, jarallaxVideo} from 'jarallax';
import {Fancybox} from "@fancyapps/ui";

// other packages here...

// window.$ = window.jQuery = jQuery;

//Load Bootstrap Libraries
//import 'bootstrap/js/dist/alert';
//import 'bootstrap/js/dist/button';
//import 'bootstrap/js/dist/carousel';
//import 'bootstrap/js/dist/collapse';
//import 'bootstrap/js/dist/dropdown'; //also requires Popper
//import 'bootstrap/js/dist/modal';
//import 'bootstrap/js/dist/offcanvas';
//import 'bootstrap/js/dist/popover'; //also requires Popper
//import 'bootstrap/js/dist/scrollspy';
//import 'bootstrap/js/dist/tab';
//import 'bootstrap/js/dist/toast';
//import Tooltip from 'bootstrap/js/dist/tooltip'; //also requires Popper

//Local imports
import { serviceWorker } from './modules/_serviceWorker.mjs';
import { validate } from './modules/_validate.mjs';
import { reviewSlider } from "./modules/_carousels.mjs";
import { gallerijSlider } from "./modules/_carousels.mjs";
import { itemFilter } from "./modules/_itemFilter.mjs";
import { Textrotator } from "./modules/_textrotator.mjs";
import { dienstenSlider } from "./modules/_carousels.mjs";

//initialize functions
document.addEventListener("DOMContentLoaded", function() {
    serviceWorker();
    validate();
    reviewSlider();
    gallerijSlider();
    itemFilter();
    dienstenSlider();
    const textrotator = new Textrotator();
    AOS.init({startEvent: 'load', disable: 'mobile'});
    //jarallax(document.querySelectorAll('.jarallax'), { speed: 0.5 });
    //jarallaxVideo();

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const filter = urlParams.get('filter');
    if (filter) {
        filter.toString();
    }

    const checkboxes = document.querySelectorAll('.js-filter-checkbox');
    if (checkboxes) {
        checkboxes.forEach(function(checkbox) {
            if (checkbox.value === filter) {
                checkbox.click();
                checkbox.closest('.filter').classList.add('active');
            }
        });
    }

    let hamburger = document.getElementById('navigation-toggler');
    let navigation = document.getElementById('main-nav');

    hamburger.addEventListener('click', function() {
        if (hamburger.classList.contains('active')) {
            hamburger.classList.remove('active');
            navigation.classList.remove('show');
            document.body.style.overflow = '';
        } else {
            hamburger.classList.add('active');
            navigation.classList.add('show');
            document.body.style.overflow = 'hidden';
        }
    });


});